import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ReportGenerateRequest } from '@context/shared/types/common';
import { firstValueFrom } from 'rxjs';
import { API_URL } from '../tokens';

@Injectable({ providedIn: 'root' })
export class ReportingService {
	private readonly api = inject(API_URL);
	private readonly http = inject(HttpClient);

	/**
	 * Requests report generation from the backend. Returns the response as a Blob
	 * (e.g. CSV). Caller is responsible for triggering download (e.g. via downloadBlob).
	 */
	generateReport(body: ReportGenerateRequest): Promise<Blob> {
		return firstValueFrom(
			this.http.post(`${this.api}/v1/reports/generate`, body, {
				responseType: 'blob',
			}),
		);
	}

	/**
	 * Sends the monthly chemical usage report for the current organization (dev + super admin only).
	 */
	sendMonthlyChemicalReport(): Promise<{ recipients: number }> {
		return firstValueFrom(
			this.http.get<{ recipients: number }>(
				`${this.api}/v1/reports/chemical/monthly/send`,
			),
		);
	}
}
